import React from 'react'
import GrammarFiles from '../components/Grammar/GrammarFiles'
import Navbar from '../components/Navbar/Navbar'

export const Grammar = () => {
  return (
    <>
        <Navbar />
        <GrammarFiles />
    </>
  )
}
